<template>
  <section id="main-container" class="main-container">
    <div class="container">
      <div class="row">
        <div class="col-md-3">
          <div class="ts-service-box text-center">
            <span class="ts-service-icon icon-squre">
              <i class="fa fa-map"></i>
            </span>
            <div class="ts-service-box-content">
              <h4>Visit Us</h4>
              <p>Zambia, Copperbelt Zambia</p>
            </div>
          </div>
        </div>
        <!-- Col 1 end -->

        <div class="col-md-3">
          <div class="ts-service-box text-center">
            <span class="ts-service-icon icon-squre">
              <i class="fa fa-envelope"></i>
            </span>
            <div class="ts-service-box-content">
              <h4>Email Us</h4>
              <p>johnsonjkm@gmail.com</p>
            </div>
          </div>
        </div>
        <!-- Col 2 end -->

        <div class="col-md-3">
          <div class="ts-service-box text-center">
            <span class="ts-service-icon icon-squre">
              <i class="fa fa-phone-square"></i>
            </span>
            <div class="ts-service-box-content">
              <h4>Call Us</h4>
              <p>+260 97 7412401</p>
            </div>
          </div>
        </div>
        <!-- Col 3 end -->

        <div class="col-md-3">
          <div class="ts-service-box text-center">
            <span class="ts-service-icon icon-squre">
              <i class="fa fa-fax"></i>
            </span>
            <div class="ts-service-box-content">
              <h4>Fax Us</h4>
              <p>+253-480-8973</p>
            </div>
          </div>
        </div>
        <!-- Col 4 end -->
      </div>
      <!-- 1st row end -->
      <!-- Content row -->
    </div>
    <!-- Conatiner end -->
  </section>
  <!-- Main container end -->
</template>

<script>
export default {
  name: "ContactUs",
  metaInfo: {
    title: "Contact Us",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content: "Johnson styles construction contact information"
      }
    ]
  }
};
</script>
